import { textStyles } from '@mangovoice/design-system/textStyles/defaultTextStyles'

export const tokenVar = (token: string): string => {
  const formatted = token
    .replace(/\./g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
  return `var(--chakra-colors-${formatted})`
}

export const shadowVar = (token: string): string => {
  const formatted = token
    .replace(/\./g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
  return `var(--chakra-shadows-${formatted})`
}

export const fontSize = (value: string | string[]): string => {
  return Array.isArray(value) ? value[0] : value
}

export const dsText = textStyles
